const intialState = {
  dropdownOptions: {},
};

const dropdownOptionsReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case 'DROPDOWN_OPTIONS_UPDATE':
      return {
        ...state,
        dropdownOptions: {
          ...state.dropdownOptions,
          ...action.payload
        }
      };
    case 'DROPDOWN_OPTIONS_RESET':
      return {
        ...state,
        dropdownOptions: {}
      };
    default:
      return state;
  }
};

export default dropdownOptionsReducer;
